// const state = {
//   apiPreUrl: 'http://'+window.location.hostname+':8008',
//   frontPreUrl: 'http://'+window.location.host
// };
const state = {
  apiPreUrl: window.location.protocol + '//' + window.location.hostname + ':8008',
  frontPreUrl: window.location.protocol + '//' + window.location.host
};


const mutations = {
  setApiPreUrl(state, url) {
    state.apiPreUrl = url;
  },
  setFrontPreUrl(state, url) {
    state.frontPreUrl = url;
  },
};

const actions = {
  setApiPreUrl({ commit }, url) {
    commit('setApiPreUrl', url);
  },
  setFrontPreUrl({ commit }, url) {
    commit('setFrontPreUrl', url);
  },
};

const getters = {
  getApiPreUrl: (state) => state.apiPreUrl,
  getFrontPreUrl: (state) => state.frontPreUrl,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};